import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Eye, ChevronLeft, ChevronRight, Loader2 } from 'lucide-react';

export const SheetLivePreview = ({ preview, loading, page, onPage, selectedCount }) => (
  <Card data-testid="qr-live-preview">
    <CardHeader className="pb-3">
      <CardTitle className="text-base flex items-center gap-2"><Eye className="w-4 h-4" />Vista previa en vivo</CardTitle>
      <CardDescription data-testid="qr-preview-status">
        {selectedCount > 0 ? `${selectedCount} carteles · ${preview?.total_pages || 1} hoja(s) A4` : 'Ejemplo — seleccioná mesas'}
      </CardDescription>
    </CardHeader>
    <CardContent>
      <div className="relative mx-auto w-full max-w-[340px] aspect-[210/297] bg-white rounded-md shadow-xl border overflow-hidden">
        {preview?.image && <img src={preview.image} alt="Vista previa A4" data-testid="qr-preview-image" className="w-full h-full object-contain" />}
        {loading && (
          <div className="absolute inset-0 bg-white/60 flex items-center justify-center">
            <Loader2 className="w-6 h-6 animate-spin text-primary" />
          </div>
        )}
      </div>
      {preview?.total_pages > 1 && (
        <div className="flex items-center justify-center gap-3 mt-3">
          <Button variant="outline" size="icon" className="h-8 w-8" disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid="qr-preview-prev">
            <ChevronLeft className="w-4 h-4" />
          </Button>
          <span className="text-sm tabular-nums" data-testid="qr-preview-page">Hoja {preview.page} de {preview.total_pages}</span>
          <Button variant="outline" size="icon" className="h-8 w-8" disabled={page >= preview.total_pages} onClick={() => onPage(page + 1)} data-testid="qr-preview-next">
            <ChevronRight className="w-4 h-4" />
          </Button>
        </div>
      )}
    </CardContent>
  </Card>
);
